import { cn } from '@vimond/theme/tailwind';

const BRAND_COLORS = {
  vipps: '#FF5B24',
  stripe: '#6772E5',
};

type Brand = keyof typeof BRAND_COLORS;
const isValidBrand = (brand: string): brand is Brand => {
  return Object.keys(BRAND_COLORS).includes(brand);
};

const getStyleFromBrand = (brand: string) => {
  const lowerCaseBrand = brand.toLowerCase() as Brand;
  if (!brand || !isValidBrand(lowerCaseBrand)) {
    return {};
  }
  return {
    borderColor: BRAND_COLORS[lowerCaseBrand],
    color: BRAND_COLORS[lowerCaseBrand],
  };
};

type PoweredByBadgeProps = {
  source: string;
  className?: string;
};

/**
 * A reusable component that displays a "Powered by [source]" badge
 * Used for payment processing services like Stripe, Vipps, etc.
 * @example
 * <PoweredByBadge source="Stripe" className="custom-class" />
 */
const PoweredByBadge = ({ className, source }: PoweredByBadgeProps) => (
  <div
    className={cn(
      'flex justify-center w-max items-center px-3 py-1 text-md text-text-highlight rounded border border-text-highlight',
      className,
    )}
    style={getStyleFromBrand(source)}
  >
    Powered by&nbsp;
    <span className="font-bold">
      {source.charAt(0).toUpperCase() + source.slice(1)}
    </span>
  </div>
);

export default PoweredByBadge;
